import { useMemo } from 'react'
import { formatContactOptions } from '../../../api/contacts/formatters'
import { Owner } from '../../../api/globalTypes'
import { locationGeneralFieldsConfig } from '../../../api/locations/formValuesConfig'
import { projectGeneralFieldsConfig } from '../../../api/projects/formValuesConfig'
import projects from '../../../api/projects/hooks'
import { ENTITY_TYPE } from '../../../common/constants'
import { projectGeneralFields } from '../../../common/forms/projects/fields'
import { useLocationValues } from '../../../hooks/useLocationValues'
import agents from '../../../api/agents/hooks'
import { formatAgentOptions } from '../../../api/agents/formatters'
import { mapValuesToFormFields } from '../../../utils/formUtils/forms'

export const useProjectGeneralFormSelectOptions = (owner: Owner) => {
    const { data: projectValues, isPending: isProjectValuesPending } = projects.FormValues.useQuery()
    const { data: agentsData, isPending: isAgentsPending } = agents.GetAgents.useQuery()

    const {locationValues, isPending: isLocationValuesPending } = useLocationValues(ENTITY_TYPE.PROJECT)
    
    const agentOptions = formatAgentOptions(agentsData)

    const projectSelectOptions = useMemo(() => {
        return mapValuesToFormFields(projectValues, projectGeneralFieldsConfig)
    }, [projectValues])

    const locationSelectOptions = useMemo(() => {
        return mapValuesToFormFields(locationValues, locationGeneralFieldsConfig)
    }, [locationValues])

    const selectOptions = useMemo(
        () => ({
            ...projectSelectOptions,
            ...locationSelectOptions,
            [projectGeneralFields.AGENT_ID]: agentOptions,
            [`${projectGeneralFields.AGENT_ID}_secondary`]: agentOptions,
            [projectGeneralFields.OWNER_ID]: formatContactOptions(owner),
        }),
        [projectSelectOptions, locationSelectOptions, agentOptions, owner]
    )

    return { selectOptions, isPending: isProjectValuesPending || isAgentsPending || isLocationValuesPending }
}
